import { OrderState } from "shared/cubiq-model-multi-asset";
import * as CubiqTS from "shared/cubiq-model-multi-asset";

export enum AlgoStateFilterType {
  ALL,
  ACTIVE,
  COMPLETED,
}

const ALGO_TERMINAL_STATES: CubiqTS.OrderState[] = [
  CubiqTS.OrderState.CANCELLED,
  CubiqTS.OrderState.FILLED,
  CubiqTS.OrderState.EXPIRED,
  CubiqTS.OrderState.REJECTED,
];

export class AlgoFilterHelper {
  public static doesStateFilterPass(
    stateFilterType: AlgoStateFilterType,
    data: { orderState: OrderState },
  ): boolean {
    let result = true;

    switch (stateFilterType) {
      case AlgoStateFilterType.ACTIVE:
        result = !ALGO_TERMINAL_STATES.includes(data?.orderState);
        break;
      case AlgoStateFilterType.COMPLETED:
        result = ALGO_TERMINAL_STATES.includes(data?.orderState);
        break;
    }
    return result;
  }
}
